import { IconsProps } from "./IconsProps";

export function IconDisconected({ width, height, color } : IconsProps){
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width ? width : "42"} height={height ? height : "42"} fill="#f00" viewBox="0 0 256 256">
      <rect width="256" height="256" fill="none"></rect>
      <line x1="48" y1="40" x2="208" y2="216" fill="none" stroke="#f00" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></line>
      <path d="M107.1,57.5A143.8,143.8,0,0,1,128,56,145.6,145.6,0,0,1,230.9,98.2" fill="none" stroke="#f00" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></path>
      <path d="M25.1,98.2A145.7,145.7,0,0,1,72.4,66.9" fill="none" stroke="#f00" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></path>
      <path d="M152.1,107A97.5,97.5,0,0,1,197,132.1" fill="none" stroke="#f00" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></path>
      <path d="M59,132.1A98.7,98.7,0,0,1,108,106" fill="none" stroke="#f00" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></path>
      <path d="M92.9,166.1a50.9,50.9,0,0,1,67.6-2.4" fill="none" stroke="#f00" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></path>
      <circle cx="128" cy="200" r="12"></circle>
    </svg>
  );
}
